<template>
  <div v-if="loading === false && log" class="containerMembership">
    <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')">
      <!-- header -->
      <HeaderBackMobile :backToHome="false" leftAction="menu"/>
      <main>
        <b-row style="margin-top:20px;
          font-size: 16px;
          color: #121C2A;">
          <b-col style="padding-left:24px;">Saldo de Pontos</b-col>
        </b-row>

        <b-row style="margin-top:20px;">
          <b-col>
            <div class="myPointsCard">
              <b-row>
                <b-col style="margin:16px 24px;
                font-style: normal;
                font-weight: normal;
                line-height: 20px;
                font-size: 14px;
                text-align: center;
                letter-spacing: 0.25px;

                color: #070A0F;
                ">
                  Você tem  <span style="font-weight:500" :style="{color: getCssColor('primary_bt')}">{{log.points.available_points}} pontos</span> e precisa<br/> de <span style="font-weight:500" :style="{color: getCssColor('primary_bt')}">{{log.level_info.points_to_next_level}} </span> para mudar de nível 😀
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <!-- circle chart -->
                  <div style="margin:0 auto; width:136px; height:136px;position:relative;">
                    <div style="width:136px; height:136px; border-radius:68px;position:absolute;opacity:0.4;" :style="{backgroundColor: getCssColor('primary_bt')}">
                    </div>
                    <div style="position:absolute; top:16px; left:16px; width:104px; height:104px; border-radius:52px; background-color:#ffffff;box-shadow: 0px 4px 20px rgba(255, 102, 56, 0.35);">
                        <svg height="104" width="104">
                          <path :d="describeArc(52, 52, 52, 0, calcRadiusMax(log.points.total_points  / log.level_info.next_level.points_needed ) * 359.9999 )"
                          :fill="getCssColor('primary_bt')"
                          />
                          <circle cx="52" cy="52" r="48"  fill="#ffffff"/>
                        </svg>
                    </div>
                    <div :style="{color: getCssColor('primary_bt')}" style="
                      width:104px;
                      height:60px;
                      position:absolute;
                      top:52px;
                      left:16px;
                      text-align:center;
                      font-weight: bold;
                      font-size:22px;">
                      {{log.level_info.current_level.label}}
                    </div>
                  </div>
                  <!-- -->
                </b-col>
              </b-row>
              <b-row>
                <b-col style="margin:16px 24px;
                font-style: normal;
                font-weight: normal;
                line-height: 16px;
                font-size: 12px;
                text-align: center;
                letter-spacing: 0.4px;

                color: #9FA2A6;

                ">
                  Até o momento já foram  <br/>obtidos <span style="font-weight:500" :style="{color: getCssColor('primary_bt')}">{{log.points.total_points}} pontos</span>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>

        

        <b-row style="margin-top:32px;
          font-size: 16px;
          color: #121C2A;">
          <b-col>Histórico de Pontos</b-col>
        </b-row>

        <b-row style="margin-top:10px;border-top:1px solid #EFEFF1;"></b-row>

        <b-row v-for="(loginfo, idxl) in sortedLog" v-bind:key="idxl" align-h="center" style="margin-top:10px;" >
          <b-col cols="8" style="border-bottom:1px solid #EFEFF1;">
            <b-row v-if="loginfo.total_price_eligible" style="margin-top:8px;color: #121C2A;font-size: 15px;">
              <b-col>R$ {{formatPrice(loginfo.total_price_eligible)}}</b-col>
            </b-row>
            <b-row style="margin-top:8px;color: #525962;font-size: 14px;">
              <b-col>{{formatDate(loginfo.creation_date)}}</b-col>
            </b-row>
            <b-row style="margin-top:8px;margin-bottom:8px;">
              <b-col>
                <div :class="{roundOnline:loginfo.transaction_type === 'ONLINE_SALE', roundStore:loginfo.transaction_type === 'OFFLINE_SALE', roundRedemption:loginfo.transaction_type === 'PRIZE_REDEMPTION' }" style="height:20px;width:120px;border-radius:10px;font-size:12px;text-align:center;">
                  {{( loginfo.transaction_type === 'ONLINE_SALE' ? 'compra online' : '')}}
                  {{( loginfo.transaction_type === 'OFFLINE_SALE' ? 'compra física' : '')}}
                  {{( loginfo.transaction_type === 'PRIZE_REDEMPTION' ? 'resgate' : '')}}
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="3" style="border-bottom:1px solid #EFEFF1;line-height:81px;color: #525962;font-size:14px;">
            {{( loginfo.transaction_type === 'PRIZE_REDEMPTION' ? '-' : '')}}{{loginfo.total_points}} pts
          </b-col>
        </b-row>

        <b-row  style="margin:40px;"></b-row>
        

      </main>
      <footer style="position:relative;">
        <!-- fixed down menu -->
        <MembershipNavigation selected="points"/>
      </footer>
    </b-container>
  </div>
  <div v-else-if="loading === true">
    <InnerLoading/>
  </div>
  <div v-else>
    <b-container fluid v-if="($mq === 'mobile' || $mq === 'tablet')">
      <!-- header -->
      <HeaderBackMobile :backToHome="false" leftAction="menu"/>
      <main>
         <b-row align-h="center" style="height: calc(100vh - 100px)">
          <b-col cols="10" style="margin-top:100px;text-align:center;font-size:20px;line-height:30px;">
            Você ainda não acumulou pontos.<br/>Quanto mais você comprar, mais pontos irá acumular <font-awesome-icon style="color:#312922;line-height:24px;font-size:24px;opacity:0.74;" :icon="['fal', 'smile-wink']"/>
          </b-col>
        </b-row>
      </main>
      <footer style="position:relative;">
        <!-- fixed down menu -->
        <MembershipNavigation selected="points"/>
      </footer>
    </b-container>
  </div>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import MembershipNavigation from '@/components/MembershipNavigation'
import HeaderBackMobile from '@/components/HeaderBackMobile.vue'
import colors from '@/mixins/colors'
import formaters from '@/mixins/formaters'
import MembershipConn from '@/connection/membership'
import graphics from '@/mixins/graphics'

import _ from 'lodash'
export default {
  data () {
    return {
      log: null,
      loading: true
    }
  },
  mixins: [colors, formaters, graphics],
  components: {InnerLoading, HeaderBackMobile, MembershipNavigation},

  mounted () {
    this.getTransactionLog () 
  },

  computed: {
    sortedLog () {
      let clone = _.clone(this.log.transaction_log)
      return clone.sort((a, b) => { return b.creation_date - a.creation_date } )
    }
  },

  methods: {
    async getTransactionLog () { 
      let result = await MembershipConn.getTransactionLog()
      if (!result.error) {
        this.log = result
      } 
      this.loading = false
    }

    
  }

}
</script>

<style lang="scss">
.containerMembership {
  background-color: #FAFAFA;
  min-height: 100vh;
}


.myPointsCard {
  width: calc(100% - 16px);
  margin: 0 auto;
  height: 283px;
  border-radius:6px;
  background-color:#ffffff;
  box-shadow: 0px 4px 20px rgba(18, 28, 42, 0.08);
}

.roundOnline {
  background-color:#FFE59C;
  color:#7C6217;
}

.roundStore {
  background-color:#FFAF93;
  color:#9E2C03;
}

.roundRedemption {
  background-color:rgb(28, 63, 0);
  color:rgb(230, 230, 230);
}

</style>
